var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.596 5.313V0H.921A.927.927 0 000 .938v18.125c0 .519.41.937.921.937h12.895c.51 0 .92-.418.92-.938V6.25H9.519a.932.932 0 01-.922-.938zm2.457 9.218a.466.466 0 01-.46.469H4.144a.466.466 0 01-.46-.469v-.312c0-.258.206-.469.46-.469h6.447c.253 0 .46.21.46.469v.312zm0-2.5a.466.466 0 01-.46.469H4.144a.466.466 0 01-.46-.469v-.312c0-.258.206-.469.46-.469h6.447c.253 0 .46.21.46.469v.312zm0-2.812v.312a.466.466 0 01-.46.469H4.144a.466.466 0 01-.46-.469V9.22c0-.258.206-.469.46-.469h6.447c.253 0 .46.21.46.469zm3.684-4.457V5H9.825V0h.234c.245 0 .48.098.652.273l3.757 3.829a.943.943 0 01.269.66z",
    fill: "#00B9EF"
  })));
}

export default SvgDoc;